import { e as s, D as o } from "./paymentContants-5702685c.mjs";
import { ProgressTrackerStatus as n } from "@nextgen-web-framework/all";
var t = /* @__PURE__ */ ((e) => (e.RETURN_APPROVED = "RETURN_APPROVED", e.RETURN_INITIATED = "RETURN_INITIATED", e.RETURN_IN_TRANSIT = "RETURN_IN_TRANSIT", e.RETURN_RECEIVED = "RETURN_RECEIVED", e.RETURN_REFUND_ISSUED = "RETURN_REFUND_ISSUED", e.RETURN_REFUND_SUCCESSFUL = "RETURN_REFUND_SUCCESSFUL", e.RETURN_COMPLETE = "RETURN_COMPLETE", e.RETURN_CANCELLED = "RETURN_CANCELLED", e))(t || {}), r = /* @__PURE__ */ ((e) => (e.REVIEW_REQUEST = "REVIEW_REQUEST", e.ITEM_RECEIVED = "ITEM_RECEIVED", e.REQUEST_APPROVED = "REQUEST_APPROVED", e))(r || {});
const l = 5e3, u = 5e3, R = [
  s.AUTHORIZED,
  s.INITIATED,
  s.CAPTURED,
  s.PAID
], g = [s.CANCELLED, s.FAILED], T = {
  FAILED: "FAILED",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS"
}, c = ["LATAM_QUALITY DISSATISFACTION", "LATAM_DEFECTIVE", "LATAM_ADVERSE REACTION"], A = {
  [o.PAID.id]: {
    aboMessage: "<p>You have earned <strong>PV {pvPoints} / BV {bvPoints}</strong> for your order <strong>{orderId}</strong></p>.",
    guestMesssage: "<p>We have sent a confirmation email to <strong>{email}</strong> for your order <strong>{orderId}</strong></p>.",
    registeredMessage: "<p>You have earned <strong>{amPoints} AmPoints </strong> for your order <strong>{orderId}</strong></p>.",
    title: "Thank you for your order!"
  },
  [o.PENDING.id]: {
    guestMesssage: "<p><strong>Payment in transaction</strong> for your order<strong>{orderId}</strong>, it may take up to 7 minutes and refresh to check the status again.</p>",
    registeredMessage: "<p><strong>Payment in transaction</strong> for your order<strong>{orderId}</strong>, it may take up to 7 minutes and refresh to check the status again.</p>",
    aboMessage: "<p><strong>Payment in transaction</strong> for your order<strong>{orderId}</strong>, it may take up to 7 minutes and refresh to check the status again.</p>",
    title: "Transaction in progress!"
  },
  [o.DENIED.id]: {
    guestMesssage: "<p>Your payment is <strong>unsuccessful</strong> for your order<strong>{orderId}</strong>. Please verify your details and retry payment.</p>",
    registeredMessage: "<p>Your payment is <strong>unsuccessful</strong> for your order<strong>{orderId}</strong>. Please verify your details and retry payment.</p>",
    aboMessage: "<p>Your payment is <strong>unsuccessful</strong> for your order<strong>{orderId}</strong>. Please verify your details and retry payment.</p>",
    title: "Payment unsuccessful!"
  },
  [o.AWAITED.id]: {
    guestMesssage: "<p>We’re currently <strong>awaiting payment</strong> for your order<strong>{orderId}</strong>. Please <strong>pay by 11:30pm, {payUntildate}.</strong></p>",
    registeredMessage: "<p>We’re currently <strong>awaiting payment</strong> for your order<strong>{orderId}</strong>. Please <strong>pay by 11:30pm, {payUntildate}.</strong></p>",
    aboMessage: "<p>We’re currently <strong>awaiting payment</strong> for your order<strong>{orderId}</strong>. Please <strong>pay by 11:30pm, {payUntildate}.</strong></p>",
    title: "Thank you for your order!"
  }
}, N = 150, I = "images/kerry-logo.png", p = "images/AmwayTabLogo.png", C = "images/KerryTextLogo.svg", D = "images/OrderNotFound.svg", _ = 3, m = [
  {
    title: "order.returnDetails.progress.reviewRequest",
    iconName: "clipboard-list",
    status: n.CURRENT,
    id: r.REVIEW_REQUEST
  },
  {
    title: "order.returnDetails.progress.itemRecieved",
    iconName: "box",
    status: n.FUTURE,
    id: r.ITEM_RECEIVED
  },
  {
    title: "order.returnDetails.progress.requestApproved",
    iconName: "stamp",
    status: n.FUTURE,
    id: r.REQUEST_APPROVED
  }
], U = [
  {
    status: r.REVIEW_REQUEST,
    returnEvent: t.RETURN_INITIATED,
    message: "order.returnDetails.returnInitiated.message",
    isCancellationAvailable: !0,
    title: "order.returnDetails.returnInitiated.title"
  },
  {
    status: r.REVIEW_REQUEST,
    returnEvent: t.RETURN_APPROVED,
    message: "order.returnDetails.requestApproved.message",
    isCancellationAvailable: !0,
    qrCodeShow: !0,
    title: "order.returnDetails.requestApproved.title"
  },
  {
    status: r.ITEM_RECEIVED,
    returnEvent: t.RETURN_IN_TRANSIT,
    message: "order.returnDetails.returnInTransit.message",
    title: "order.returnDetails.returnInTransit.title"
  },
  {
    status: r.ITEM_RECEIVED,
    returnEvent: t.RETURN_RECEIVED,
    message: "order.returnDetails.returnReceived.message",
    title: "order.returnDetails.returnReceived.title"
  },
  {
    status: r.REQUEST_APPROVED,
    returnEvent: t.RETURN_REFUND_ISSUED,
    message: "order.returnDetails.returnRefund.message",
    title: "order.returnDetails.returnRefund.title"
  },
  {
    status: r.REQUEST_APPROVED,
    returnEvent: t.RETURN_REFUND_SUCCESSFUL,
    message: "order.returnDetails.returnRefund.message",
    title: "order.returnDetails.refundCompleted.title"
  },
  {
    status: r.REQUEST_APPROVED,
    returnEvent: t.RETURN_COMPLETE,
    message: "",
    title: "order.returnDetails.requestCompleted.title"
  },
  {
    status: "",
    returnEvent: t.RETURN_CANCELLED,
    message: "",
    title: "order.returnDetails.requestCancelled.title"
  }
], P = {
  purple: "#38539A",
  white: "#ffffff"
};
var a = /* @__PURE__ */ ((e) => (e.ALL = "ALL", e.ToPAY = "ToPAY", e.ToRECEIVE = "ToRECEIVE", e.COMPLETED = "COMPLETED", e.CANCELLED = "CANCELLED", e.MULTIPLE_CONSIGNMENTS = "MULTIPLE_CONSIGNMENTS", e))(a || {});
const y = [
  {
    title: "order.pillFilters.all",
    filter: "",
    id: "ALL"
    /* ALL */
  },
  {
    title: "order.pillFilters.toPay",
    filter: "toPay:true",
    id: "ToPAY"
    /* ToPAY */
  },
  {
    title: "order.pillFilters.toReceive",
    filter: "toReceive:true",
    id: "ToRECEIVE"
    /* ToRECEIVE */
  },
  {
    title: "order.pillFilters.completed",
    filter: "hasCompleted:true",
    id: "COMPLETED"
    /* COMPLETED */
  },
  {
    title: "order.pillFilters.cancelled",
    filter: "orderStatus:CANCELLED",
    id: "CANCELLED"
    /* CANCELLED */
  },
  {
    title: "order.pillFilters.multipleConsignments",
    filter: "multiShipments:true",
    id: "MULTIPLE_CONSIGNMENTS"
    /* MULTIPLE_CONSIGNMENTS */
  }
], d = "EX-04A:Cancel002", O = [
  {
    code: "EX-04A:Cancel001",
    message: "order.orderCancellation.message.noValid"
  },
  {
    code: d,
    message: "order.orderCancellation.message.failed",
    body: "order.orderCancellation.message.failedInfo"
  },
  {
    code: "EX-04A:Cancel003",
    message: "order.orderCancellation.message.noValid"
  },
  {
    code: "EX-04A:Cancel005",
    message: "order.orderCancellation.message.inProgress"
  }
], M = {
  title: "order.pageError.message",
  description: "order.pageError.subHeading",
  imgUrl: "images/PostpurchaseMaintenance.svg"
}, S = {
  orderDetails: "order-details",
  orderHistory: "order-history",
  returnDetails: "return-details"
}, f = {
  browserBackWarn: "browserBackWarn"
}, L = {
  "Commerce Web": "order.salesOrderChannel.commerceWeb",
  "Recurring Order": "order.salesOrderChannel.recurringOrder"
}, h = {
  standard: "order.deliveryOption.standard",
  express: "order.deliveryOption.express",
  premium: "order.deliveryOption.premium"
}, v = {
  CREDIT_DEBIT_CARD: "order.refundMethod.creditDebitCard",
  INSTALLMENT_PAYMENT: "order.refundMethod.installment",
  ONLINE_BANKING: "order.refundMethod.onlineBanking",
  PAY_LATER: "order.refundMethod.paylater",
  QR_CODE: "order.refundMethod.qrcode",
  AMWAY_POINTS: "order.refundMethod.amwayPoints",
  CREDIT_VOUCHER: "order.refundMethod.creditVoucher",
  ON_ACCOUNT_BALANCE: "order.refundMethod.onAccountBalance",
  CASH: "order.refundMethod.cash",
  GROUP_PAYMENT: "order.refundMethod.groupPayment",
  NGC_ROUNDING_PAYMENT: "order.refundMethod.ngcRoundingPayment",
  BANK_PAYOUT: "order.refundMethod.bankPayout",
  // For MANUAL_PAYOUT, bank payout label should be displayed.
  MANUAL_PAYOUT: "order.refundMethod.bankPayout"
}, V = 5;
export {
  p as A,
  f as B,
  l as C,
  h as D,
  M as E,
  g as F,
  I as K,
  c as L,
  _ as M,
  O,
  a as P,
  v as R,
  L as S,
  N as T,
  d as a,
  D as b,
  y as c,
  S as d,
  t as e,
  V as f,
  U as g,
  P as h,
  m as i,
  u as j,
  R as k,
  T as l,
  A as m,
  C as n
};
//# sourceMappingURL=constant-23063292.mjs.map
